<template>
  <div id="bjzc-service-detail">
    <PageHeading>{{ $t('service.name') }}</PageHeading>
    <div class="bjzc-page-content">
      <div class="uk-flex-none">
        <Tabs v-model="serviceId" :options="tabsOptions" @change="handleTabChange" />
      </div>
      <div class="uk-flex-1 border-radius">
        <h4>{{ $getLocaleValue(serviceInfo, 'title') }}</h4>
        <div v-html="$getLocaleValue(serviceInfo, 'content')"></div>

        <ContactForm />
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from '../components/Tabs.vue'
import ContactForm from '../components/ContactForm.vue'
import { services } from '../lib/options'
export default {
  components: { Tabs, ContactForm },
  data() {
    return {
      serviceId: '',
      serviceInfo: {
        title: '刑事案件',
        describe: '',
        content: ''
      }
    }
  },
  computed: {
    tabsOptions() {
      return services.map(s => ({
        name: this.$t(`service.${s}`),
        value: s,
        imagePath: 'service/' + s + '.png'
      }))
    }
  },
  methods: {
    getDetail(code) {
      this.$axios.get('single_pages/info', { params: { code } }).then(res => {
        this.serviceInfo = res.data
      })
    },
    handleTabChange(v) {
      this.$router.push({
        params: { id: v }
      })
    }
  },
  watch: {
    $route: {
      handler(r) {
        this.getDetail(r.params.id)
        this.serviceId = r.params.id
        this.$eventBus.$emit('setBreadcrumb', [
          { path: '/', title: '首页', title_en: 'Home' },
          {
            path: '/service',
            title: this.$t('breadcrumb.service', 'zh'),
            title_en: this.$t('breadcrumb.service', 'en')
          },
          {
            path: r.fullPath,
            title: this.$t(`service.${r.params.id}`, 'zh'),
            title_en: this.$t(`service.${r.params.id}`, 'en')
          }
        ])
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
#bjzc-service-detail {
  .bjzc-page-content {
    display: flex;
    & > :nth-child(2) {
      padding: 2.5rem;
      background-color: #fff;
    }

    p > :nth-child(1) {
      font-weight: 500;
    }

    // .bjzc-contact-form {
    //   margin-top: 2.5rem;
    // }
  }
}
@media (max-width: ($screen-width-m - 1)) {
  #bjzc-service-detail {
    .bjzc-page-content {
      flex-direction: column;
      & > :nth-child(2) {
        padding: 0;
      }
    }
  }
}
</style>
